import React, { useEffect, useState } from "react";
import { MdGroups, MdManageAccounts } from "react-icons/md";
import UserManagementTable from "./components/UserManagementTable";
import api from "../../../services/axios";
import SkeletonTable from "../../../components/skeleton/table";

const UserManagement = () => {
  const [userData, setUserData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const columns = [
    { key: "id", header: "ID" },
    { key: "userName", header: "Nome" },
    { key: "email", header: "E-mail" },
    { key: "jobDescription", header: "Cargo" },
    { key: "dtOfBirth", header: "Nascimento" },
  ];

  useEffect(() => {
    setLoading(true);
    function fetchEmployees() {
      api
        .get("/Employee/employees")
        .then((response) => {
          setUserData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
          setLoading(true);
        });
    }
    fetchEmployees();
  }, []);

  return (
    <div className="mt-5 animate-fade-up">
      {/* ── Page header ─────────────────────────────────────────────── */}
      <div className="mb-5 flex items-center gap-4">
        <span
          className="dv-aura flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow"
          aria-hidden="true"
        >
          <MdGroups className="h-6 w-6" />
        </span>
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-dv-blue-500/10 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.18em] text-dv-blue-600 dark:text-dv-cyan-300">
            <MdManageAccounts className="h-3.5 w-3.5" aria-hidden="true" />
            Gestão de acessos
          </span>
          <h1 className="mt-1.5 text-2xl font-extrabold tracking-tight text-navy-700 dark:text-white">
            Usuários
          </h1>
        </div>
      </div>

      <div className="grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        {loading ? (
          <SkeletonTable active={loading} />
        ) : (
          <UserManagementTable columns={columns} data={userData} />
        )}
      </div>
    </div>
  );
};

export default UserManagement;
